import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const MinusIcon = createSvgIcon(
  <svg width="9" height="3" viewBox="0 0 9 3" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.98952 2.86087H0.287517V0.884874H8.98952V2.86087Z" fill="currentColor" />
  </svg>,
  'minus'
);
